import { createFileRoute } from '@tanstack/react-router'

import { ResetPasswordPage } from '@/features/auth/pages/reset-password'

// Rendered through a wrapper, not passed directly: the page is typed
// `NextPageWithLayout` (a `ComponentType`, so a class component is in the
// union) while a route `component` must be a function component. The
// `getLayout = (page) => page` opt-out these pages carry is what put them
// under _bare in the first place, so nothing else is lost.
export const Route = createFileRoute('/_bare/reset-password')({
  component: () => <ResetPasswordPage />,
})
